import { Box } from '@radix-ui/themes';
import { RefObject } from 'react';
import { ParallaxLayer } from './ParallaxLayer';

interface ParallaxImageProps {
    imageUrl?: string;
    scrollRef: RefObject<HTMLElement | null>;
    speed?: number;
    gradientColor?: string;
}

export const ParallaxImage = ({
    imageUrl,
    scrollRef,
    speed = 0.25,
    gradientColor = 'var(--gray-1)',
}: ParallaxImageProps) => {
    const fallbackImageUrl = `/images/background/background_2.jpg`;
    const finalImageUrl = imageUrl || fallbackImageUrl;

    const overlayGradient =
        'linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.85))';
    const bottomFadeGradient = `linear-gradient(to bottom, transparent 33%, ${gradientColor} 100%)`;

    const combinedBackground = `${bottomFadeGradient}, ${overlayGradient}, url(${finalImageUrl})`;

    return (
        <ParallaxLayer scrollContainerRef={scrollRef} speed={speed} zIndex={0}>
            <Box
                width='100%'
                height='100%'
                style={{
                    backgroundImage: combinedBackground,
                    backgroundSize: 'cover',
                }}
            />
        </ParallaxLayer>
    );
};
